module.exports = __webpack_public_path__ + "img/1510610914.6cf2907e.jpg";